import React, { useState, useEffect, useCallback } from "react";
import styles from "./inventorySliderComponents.module.scss";
import DaySelectionWeekDays from "./DaySelectionWeekDays";
import SelectDateRange from "./SelectDateRange";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import ToggleSwitch from "./Switch/ToggleSwitch";
import DateRangePicker from "./DateRangePicker/DateRangePicker";
import InventoryMultipleDatesRangesAndWeekDays from "./InventoryMultipleDatesRangesAndWeekDays";

const SliderInventoryUpdate = ({
  categories,
  currentDate,
  baseUrl,
  property_id,
  userToken,
  setLoader,
  channels,
  setShow,
  disabledSelectChannelOptions,
  defaultSelectedChannel,
  activeApp,
  fetchInfo,
  uniqueChannelId,
  viewType,
  room_id,
  channel_id,
  propertyCurrentDate,
}) => {
  // update api call function

  const fetchInventoryData = async () => {
    if (activeApp === "pms") {
      fetchInfo(property_id?.id, uniqueChannelId);
    } else if (activeApp === "channel_manager") {
      viewType === "channel_view"
        ? fetchInfo(property_id?.id, room_id, viewType)
        : fetchInfo(property_id?.id, channel_id, viewType);
    } else {
    }
  };

  const [dates, setDates] = useState({ from_date: "", to_date: "" });

  const [dateRanges, setDateRanges] = useState([
    {
      id: 1,
      dates: { from_date: "", to_date: "" },
      days: {},
    },
  ]);

  const [days, setDays] = useState({});

  const handleDaysChange = useCallback((data) => {
    setDays(data);
  }, []);

  const [inventoryData, setInventoryData] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      if (!inventoryData.some((item) => item.roomId === parseInt(value))) {
        setInventoryData([
          ...inventoryData,
          { roomId: parseInt(value), available_rooms: "" },
        ]);
      }
    } else {
      // Remove the item from inventoryData if unchecked
      setInventoryData(
        inventoryData.filter((item) => item.roomId !== parseInt(value))
      );
    }
  };

  const handleInputChange = (event, roomId) => {
    const { value } = event.target;

    setInventoryData(
      inventoryData.map((item) =>
        item.roomId === roomId
          ? { ...item, available_rooms: parseInt(value) || "" }
          : item
      )
    );
  };

  const [selectedChannel, setSelectedChannel] = useState([]);

  useEffect(() => {
    if (defaultSelectedChannel && defaultSelectedChannel.length > 0) {
      setSelectedChannel(defaultSelectedChannel);
    }
  }, [defaultSelectedChannel]);

  const updateStayRestrictions = async () => {
    // Validation checks
    if (activeApp === "channel_manager" && selectedChannel.length === 0) {
      showErrorToast("Please select at least one channel.");
      return;
    }

    if (inventoryData.length === 0) {
      showErrorToast("Please add inventory data.");
      return;
    }

    for (let item of inventoryData) {
      if (!item.available_rooms || item.available_rooms === "") {
        showErrorToast(
          "Please ensure all selected rooms have available rooms specified."
        );
        return;
      }
    }

    if (!dates || !dates.from_date || !dates.to_date) {
      showErrorToast("Please select both 'from' and 'to' dates.");
      return;
    }

    if (Object.keys(days).length === 0) {
      showErrorToast("Please select at least one day.");
      return;
    }

    const postData = {
      from_date: dates.from_date,
      to_date: dates.to_date,
      channels: selectedChannel,
      inventory_data: inventoryData,
      ...days,

      ...restrictions,
    };

    // console.log("postData", postData);

    try {
      setLoader(true);

      const response = await fetch(
        `${baseUrl}/api/v1/update/inventory/${property_id?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          method: "POST",
          body: JSON.stringify(postData),
        }
      );

      const data = await response.json();
      if (data.success) {
        showSuccessToast(data.message);
        setShow(false);
        setTimeout(() => {
          fetchInventoryData();
        }, [500]);
      } else {
        showErrorToast(
          data.message || data.error || "Failed to update stay restrictions."
        );
      }
    } catch (error) {
      console.error("An error occurred:", error);
      showErrorToast("An error occurred while updating stay restrictions.");
    } finally {
      setLoader(false);
    }
  };

  console.log(dateRanges, 'dateRanges');


  const updateInventory = async () => {
    for (let item of dateRanges) {
      if (!item?.dates?.from_date || !item?.dates?.to_date) {
        showErrorToast("Please select both 'from' and 'to' dates.");
        return;
      }

      if (Object.keys(item?.days).length === 0) {
        showErrorToast("Please select at least one day.");
        return;
      }
    }

    if (inventoryData.length === 0) {
      showErrorToast("Please add inventory data.");
      return;
    }

    for (let item of inventoryData) {
      if (!item.available_rooms || item.available_rooms === "") {
        showErrorToast(
          "Please ensure all selected rooms have available rooms specified."
        );
        return;
      }
    }

    const headers = {
      "X-Channel-Token": "PoGC1kGsepDYT7lQ4Azqmmou03oqFbHA    mmm",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${userToken}`,
      "Cookie": process.env.REACT_APP_COOKIE,
    };

    const formattedInventory = inventoryData?.map(item => ({
      roomCode: item.roomId,
      count: item.available_rooms,
      closed: false
    }));

    const formatDateRanges = dateRanges?.map((range) => {
      const base = {
        from: range.dates.from_date,
        to: range.dates.to_date
      };

      if (Object.keys(range.days || {}).length > 0) {
        return {
          ...base,
          ...range.days
        };
      }

      return base;
    });

    const body = JSON.stringify({
      hotelCode: property_id,
      hotelInvCountNotif: [
        {
          dateRanges: formatDateRanges,
          inventory: formattedInventory
        }
      ]
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v2/channel-manager/inventory/update`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow"
        }
      );

      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.error("Error updating inventory:", error);
    }
  };

  const handleCloseBookingSlider = () => {
    setShow(false);
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, [1000]);
  };

  const handleCheckboxChangeChannel = (event) => {
    const { value, checked } = event.target;
    const channel_id = value;
    const channel_name = event.target.dataset.name;

    setSelectedChannel((prevSelectedChannels) => {
      if (checked) {
        // Check if the channel is already selected
        const isAlreadySelected = prevSelectedChannels.some(
          (channel) => +channel.channel_id === +channel_id
        );

        if (!isAlreadySelected) {
          // If not already selected, add to the array
          return [...prevSelectedChannels, { channel_id, channel_name }];
        }
      } else {
        // If unchecked, remove from the array
        return prevSelectedChannels.filter(
          (channel) => +channel.channel_id !== +channel_id
        );
      }

      // If already selected and checked, return the current state without changes
      return prevSelectedChannels;
    });
  };

  //  restrictions code
  const [restrictions, setRestrictions] = useState({
    restrictions: false, // changed from "" to false
    closedToArrival: false,
    closedToDeparture: false,
    minLOS: "",
    maxLOS: "",
  });

  const handleCloseToArrivalDepartureChange = (value, name) => {
    setRestrictions((prevRestrictions) => ({
      ...prevRestrictions,
      [name]: value ? true : false,
    }));
  };

  const handleMinMaxLOSChange = (e) => {
    const { name, value } = e.target;
    setRestrictions((prevRestrictions) => ({
      ...prevRestrictions,
      [name]: +value,
    }));
  };

  const handleRestrictionsChange = (value, name) => {
    setRestrictions({
      ...restrictions,
      [name]: value,
    });
  };

  return (
    <>
      <div className={styles.container}>
        {/* <div style={{ width: "100%" }}>
          <div style={{ paddingBottom: "5px" }}>Select Date Range</div>
          <DateRangePicker
            size={"medium"}
            onChange={(from_date, to_date) =>
              // handleDateChange(range.id, from_date, to_date)
              setDates({
                from_date: from_date,
                to_date: to_date,
              })
            }
            // disabled={index === dateRanges.length - 1 ? false : true}
            minDate={new Date(propertyCurrentDate)}
          />

        </div>
        <hr />
        <div>
          <DaySelectionWeekDays onSaveDates={handleDaysChange} />
        </div> */}

        <div>
          <InventoryMultipleDatesRangesAndWeekDays
            dateRanges={dateRanges}
            setDateRanges={setDateRanges}
            propertyCurrentDate={propertyCurrentDate}
          />
        </div>
        <hr />

        <div>
          <div className={styles.headings}>Select Room Categories</div>
          {categories.map((room) => {
            const inventoryItem = inventoryData.find(
              (item) => item.roomId === room.roomId
            );

            return (
              <div
                key={room.roomId}
                className="flex justify_content_between align_items_center"
                style={{ margin: "5px 0" }}
              >
                <div className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    name="update_type"
                    onChange={handleCheckboxChange}
                    value={room.roomId}
                    checked={!!inventoryItem}
                    style={{ marginRight: "10px" }}
                    id={room.roomId + "-" + room.name}
                  />
                  <label htmlFor={room.roomId + "-" + room.name}>
                    {room.name || room.name}
                  </label>
                </div>

                {inventoryItem && (
                  <input
                    type="number"
                    value={inventoryItem.available_rooms}
                    onChange={(e) =>
                      handleInputChange(e, room.roomId || room.name)
                    }
                    className={styles.inputRoomData}
                  />
                )}
              </div>
            );
          })}
        </div>

        <hr />

        {/* {activeApp === "channel_manager" && (
          <div>
            <div>
              <div className={styles.headings}>Select Channels</div>

              <div
                className="flex flex_direction_col flex_gap_10"
                style={{
                  color: "#333",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {channels &&
                  channels.length > 0 &&
                  channels.map((room) => (
                    <div
                      key={room.channel_id}
                      className={styles.checkboxContainer}
                    >
                      <input
                        type="checkbox"
                        value={room.channel_id}
                        data-name={room.channel_name}
                        onChange={handleCheckboxChangeChannel}
                        style={{ marginRight: "10px" }}
                        disabled={disabledSelectChannelOptions}
                        checked={selectedChannel.some(
                          (selected) =>
                            String(selected.channel_id) ===
                            String(room.channel_id)
                        )}
                        id={room.channel_id + "-" + room.channel_name}
                      />
                      <label
                        htmlFor={room.channel_id + "-" + room.channel_name}
                      >
                        {room.channel_name}
                      </label>
                    </div>
                  ))}
              </div>
            </div>

            <hr />
          </div>
        )} */}

        {/* //  restrictions   */}
        {/* <div>
          <div
            className={`${styles.headings} flex align_items_center flex flex_gap_10`}
          >
            <label htmlFor="restrictions">Restrictions</label>
            <ToggleSwitch
              name="restrictions"
              isOn={restrictions.restrictions}
              size="medium"
              handleToggle={handleRestrictionsChange}
            />
          </div>

          {restrictions.restrictions ? (
            <>
              <div className="flex align_items_center justify_content_between">
                Min Los
                <input
                  type="number"
                  value={restrictions.minLOS}
                  className={styles.inputRoomData}
                  onChange={handleMinMaxLOSChange}
                  name="minLOS"
                  min="1"
                />
              </div>

              <div className="flex align_items_center justify_content_between mt-10">
                Max Los
                <input
                  type="number"
                  value={restrictions.maxLOS}
                  className={styles.inputRoomData}
                  name="maxLOS"
                  onChange={handleMinMaxLOSChange}
                />
              </div>

              <div className="flex align_items_center justify_content_between mt-10">
                Close to Arrival
                <ToggleSwitch
                  isOn={restrictions.closedToArrival}
                  name="closedToArrival"
                  size="small"
                  handleToggle={handleCloseToArrivalDepartureChange}
                />
              </div>

              <div className="flex align_items_center justify_content_between mt-10">
                Close to Departure
                <ToggleSwitch
                  isOn={restrictions.closedToDeparture}
                  name="closedToDeparture"
                  size="small"
                  handleToggle={handleCloseToArrivalDepartureChange}
                />
              </div>
            </>
          ) : (
            <p>No restrictions added</p>
          )}
        </div> */}
      </div>

      <div
        className={`flex align_items_center flex_gap_10 ${styles.buttonContainer}`}
      >
        {/* <BgThemeButton
          type="submit"
          onClick={updateStayRestrictions}
          children={"Update"}
        />

        <Button onClick={handleCloseBookingSlider}>Cancel</Button> */}
        <button
        disabled
          type="submit"
          style={{opacity: 0.5}}
          // className="vendor_common_property pointer"
          onClick={updateInventory}>Update</button>

        {/* <button onClick={handleCloseBookingSlider}>Cancel</button> */}

        <button
          className="no_logout_btn"
          onClick={handleCloseBookingSlider}                >
          Cancel
        </button>
      </div>
    </>
  );
};

export default SliderInventoryUpdate;
